
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { CardBody, Card, CardTitle, FormGroup, Input, Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { setStatus } from '../../../actions/adminActions'
import { FaInfoCircle } from 'react-icons/fa'

class Status extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.modalToggle = this.modalToggle.bind(this)
    this.state = {
      modal: false
    }
  }

  handleChange (event) {
    this.props.setStatus(event.target.value, true)
  }

  modalToggle () {
    this.setState({
      modal: !this.state.modal
    })
  }

  render () {
    return (
      <div>
        <Card>
          <CardTitle>Status <span className='ml-3' onClick={this.modalToggle}><FaInfoCircle /></span></CardTitle>
          <CardBody>
            <FormGroup>
              <Input type='select' value={this.props.admin.appeal.status} onChange={this.handleChange} name='status' id='status'>
                <option value='registering'>Registering</option>
                <option value='registered'>Registered</option>
                <option value='submitted'>Submitted</option>
                <option value='writing'>Writing</option>
                <option value='pending appellant response'>Pending appellant response</option>
                <option value='pending adjudicator response'>Pending adjudicator response</option>
                <option value='accepted'>Accepted</option>
                <option value='rejected'>Rejected</option>
                <option value='breach'>Breach</option>
              </Input>
            </FormGroup>
            <p>Use this will caution. Status changes are automatically made as appeals progress.</p>
          </CardBody>
        </Card>
        <Modal isOpen={this.state.modal} toggle={this.modalToggle}>
          <ModalHeader toggle={this.modalToggle}>Status Guide</ModalHeader>
          <ModalBody>
            <p>The appeal status changes automatically, but this can be manually overidden. Please use with caution.</p>
            <br />
            <p><b>Registering:</b> Appellant has entered email and PCN but has not yet logged in.</p>
            <p><b>Registered:</b> Appellant logged in successfully.</p>
            <p><b>Writing:</b> Appellant started writing some of their appeal.</p>
            <p><b>Submitted:</b> Appellant has submitted appeal.</p>
            <p><b>Pending appellant response:</b> A message has been sent to appellant.</p>
            <p><b>Pending adjudicator response:</b> Appellant has sent message to adjudicator.</p>
            <p><b>Accepted:</b> Appeal has been accepted.</p>
            <p><b>Rejected:</b> Appeal has been rejected.</p>
            <p><b>Breach:</b> Appeal had incorrect registration, records breach of data.</p>

          </ModalBody>
          <ModalFooter>
            <Button color='secondary' onClick={this.modalToggle}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

Status.propTypes = {
  admin: PropTypes.object,
  setStatus: PropTypes.func
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setStatus
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Status))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminAppeal/_Status.jsx